// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-wrapper {
	background-color: var(--background);
	min-height: 100vh;
}

.register-first-step-wrapper {
	height: 100vh;
	display: grid;
	grid-template-columns: 1fr 600px;
}

.register-right-side {
	height: 100%;
	width: 100%;
	background-color: var(--button);
	display: flex;
	justify-content: center;
	align-items: center;
}

.register-right-side img {
	max-width: 520px;
	width: 100%;
}

.register-first-step__form {
	display: flex;
	flex-direction: column;
	padding: 80px;
	height: 100vh;
	overflow-y: auto;
	position: relative;
	margin: auto 0;
	gap: 24px;
}

.register-first-step__back {
	position: fixed;
	top: 20px;
	left: 20px;
	color: var(--text);
	font-size: 20px;
	cursor: pointer;
	width: 40px;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	background-color: var(--button);
	transition: 0.3s;
}

.register-first-step__back:hover {
	background-color: var(--button-hover);
	transition: 0.3s;
}

.auth-title {
	font-family: "Poppins", sans-serif;
	font-size: 32px;
	line-height: 42px;
	color: var(--dark);
}

.register-first-step__fields {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 24px;
}

.register-first-step__have-account {
	font-family: "Poppins", sans-serif;
	font-size: 16px;
	line-height: 20px;
	margin-top: 8px;
}

.register-first-step__have-account a {
	color: var(--dark) !important;
	text-decoration: underline !important;
}

.auth-form-input {
	border: 1px solid var(--border-transparent) !important;
	height: 56px;
	font-family: "Poppins", sans-serif !important;
	border-radius: 12px !important;
}

.register-first-step__agree-to-terms {
	font-size: 16px;
	line-height: 20px;
	font-family: "Poppins", sans-serif;
	color: var(--dark);
	margin-top: 8px;
}

.register-first-step__agree-to-terms a {
	color: var(--dark) !important;
	text-decoration: underline !important;
}

.register-first-step__button-wrapper {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.register-first-step__button-wrapper button {
	height: 56px;
	width: fit-content;
	border-radius: 12px;
	font-family: "Poppins", sans-serif;
	font-size: 18px;
	line-height: 22px;
	color: var(--background);
	background-color: var(--button);
	border: none;
	cursor: pointer;
	font-weight: 500;
	transition: 0.3s;
}

.register-first-step__button-wrapper button:disabled {
	opacity: 0.5;
}

.register-first-step__button-wrapper button:disabled:hover {
	background-color: var(--button);
}

.register-first-step__button-wrapper button:hover {
	background-color: var(--button-hover);
	transition: 0.3s;
}

.register-first-step__tiktok-banner {
	background-color: var(--button);
	border-radius: 12px;
	padding: 16px;
	display: flex;
	align-items: center;
	gap: 16px;
	color: #FFFFFF;
}

.register-first-step__tiktok-banner-content {
	display: flex;
	align-items: center;
	gap: 16px;
}

@media (max-width: 1150px) {
	.register-first-step-wrapper {
		height: 100vh;
		display: grid;
		grid-template-columns: 1fr 450px;
	}

	.register-right-side {
		height: 100%;
		width: 100%;
		background-color: var(--button);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.register-right-side img {
		max-width: 400px;
		width: 100%;
	}

	.register-first-step__form {
		display: flex;
		flex-direction: column;
		padding: 40px;
		height: 100vh;
		overflow-y: auto;
		position: relative;
		margin: auto 0;
		gap: 24px;
	}
}

@media (max-width: 950px) {
	.register-first-step-wrapper {
		height: 100vh;
		display: grid;
		grid-template-columns: 1fr;
	}

	.register-right-side {
		height: 100%;
		width: 100%;
		background-color: var(--button);
		display: none;
		justify-content: center;
		align-items: center;
	}

	.register-first-step__form {
		display: flex;
		flex-direction: column;
		padding: 50px 20px;
		height: 100vh;
		overflow-y: auto;
		position: relative;
		justify-content: start;
		gap: 16px;
	}

	.register-first-step__fields {
		display: grid;
		grid-template-columns: 1fr;
		gap: 16px;
	}

	.register-first-step__back {
		position: fixed;
		top: 16px;
		left: 20px;
		color: var(--text);
		font-size: 20px;
		cursor: pointer;
		width: 40px;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		background-color: var(--button);
		transition: 0.3s;
	}

	.auth-title {
		font-family: "Poppins", sans-serif;
		font-size: 22px;
		line-height: 26px;
		color: var(--dark);
	}

	.register-first-step__have-account {
		font-family: "Poppins", sans-serif;
		font-size: 15px;
		line-height: 18px;
		margin-top: 8px;
	}

	.register-first-step__agree-to-terms {
		font-size: 15px;
		line-height: 18px;
		font-family: "Poppins", sans-serif;
		color: var(--dark);
		margin-top: 8px;
	}
}

.registration-username-hint {
	opacity: 0.3;
	position: absolute;
	left: 356px;
	top: 30%;
}

.domain-style {
	color: #a8a8a8b7;
	padding-right: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
}

.register-input-relative-group {
	position: relative;
	/* border-radius: 12px; */
	/* overflow: hidden; */
	width: 100%;
}

.register-input-group-domain {
	position: absolute;
	top: 1px;
	right: 1px;
	border-top-right-radius: 13px;
	border-bottom-right-radius: 13px;
	height: calc(100% - 2px);
}

.block-affiliate-code {
	position: relative;
}

.affiliate-code-check-loading {
	animation: spin 1s infinite linear;
	position: absolute;
	right: 16px;
	top: 50%;
	transform: translateY(-50%);
	color: rgb(144, 144, 226);
}

.affiliate-code-check-done {
	position: absolute;
	right: 16px;
	top: 50%;
	transform: translateY(-50%);
	color: rgb(16, 181, 16);
}

.affiliate-code-check-error {
	position: absolute;
	right: 16px;
	top: 50%;
	transform: translateY(-50%);
	color: red;
}

.affiliate-code-tooltip-error > .tooltip-inner {
	background-color: #ffe8e8;
	color: red;
	border: 1px solid red;
	position: relative;
	left: 450px;
	bottom: 10px;
}

.affiliate-code-tooltip-error > .tooltip-arrow {
	display: none !important;
}

@keyframes spin {
	from {
		transform: scale(1) rotate(0deg);
	}

	to {
		transform: scale(1) rotate(360deg);
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/LendingPage/Auth/Register/RegisterFirstStep/RegisterFirstStep.css"],"names":[],"mappings":"AAAA;CACC,mCAAmC;CACnC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,aAAa;CACb,gCAAgC;AACjC;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,+BAA+B;CAC/B,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,aAAa;CACb,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;CACd,SAAS;AACV;;AAEA;CACC,eAAe;CACf,SAAS;CACT,UAAU;CACV,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,WAAW;CACX,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,6BAA6B;CAC7B,qCAAqC;AACtC;;AAEA;CACC,sDAAsD;CACtD,YAAY;CACZ,6CAA6C;CAC7C,8BAA8B;AAC/B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,6BAA6B;CAC7B,qCAAqC;AACtC;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,kCAAkC;CAClC,eAAe;CACf,iBAAiB;CACjB,wBAAwB;CACxB,+BAA+B;CAC/B,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,mBAAmB;CACnB,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC;EACC,aAAa;EACb,aAAa;EACb,gCAAgC;CACjC;;CAEA;EACC,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;EAChB,WAAW;CACZ;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,SAAS;CACV;AACD;;AAEA;CACC;EACC,aAAa;EACb,aAAa;EACb,0BAA0B;CAC3B;;CAEA;EACC,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;CACV;;CAEA;EACC,aAAa;EACb,0BAA0B;EAC1B,SAAS;CACV;;CAEA;EACC,eAAe;EACf,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;CACjB;;CAEA;EACC,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;CAChB;AACD;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,QAAQ;AACT;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,6BAA6B;CAC7B,gCAAgC;CAChC,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kCAAkC;CAClC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,2BAA2B;CAC3B,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,2BAA2B;CAC3B,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,UAAU;CACV,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC;EACC,gCAAgC;CACjC;;CAEA;EACC,kCAAkC;CACnC;AACD","sourcesContent":[".register-wrapper {\n\tbackground-color: var(--background);\n\tmin-height: 100vh;\n}\n\n.register-first-step-wrapper {\n\theight: 100vh;\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 600px;\n}\n\n.register-right-side {\n\theight: 100%;\n\twidth: 100%;\n\tbackground-color: var(--button);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.register-right-side img {\n\tmax-width: 520px;\n\twidth: 100%;\n}\n\n.register-first-step__form {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 80px;\n\theight: 100vh;\n\toverflow-y: auto;\n\tposition: relative;\n\tmargin: auto 0;\n\tgap: 24px;\n}\n\n.register-first-step__back {\n\tposition: fixed;\n\ttop: 20px;\n\tleft: 20px;\n\tcolor: var(--text);\n\tfont-size: 20px;\n\tcursor: pointer;\n\twidth: 40px;\n\theight: 40px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 50%;\n\tbackground-color: var(--button);\n\ttransition: 0.3s;\n}\n\n.register-first-step__back:hover {\n\tbackground-color: var(--button-hover);\n\ttransition: 0.3s;\n}\n\n.auth-title {\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-size: 32px;\n\tline-height: 42px;\n\tcolor: var(--dark);\n}\n\n.register-first-step__fields {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 24px;\n}\n\n.register-first-step__have-account {\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tmargin-top: 8px;\n}\n\n.register-first-step__have-account a {\n\tcolor: var(--dark) !important;\n\ttext-decoration: underline !important;\n}\n\n.auth-form-input {\n\tborder: 1px solid var(--border-transparent) !important;\n\theight: 56px;\n\tfont-family: \"Poppins\", sans-serif !important;\n\tborder-radius: 12px !important;\n}\n\n.register-first-step__agree-to-terms {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tfont-family: \"Poppins\", sans-serif;\n\tcolor: var(--dark);\n\tmargin-top: 8px;\n}\n\n.register-first-step__agree-to-terms a {\n\tcolor: var(--dark) !important;\n\ttext-decoration: underline !important;\n}\n\n.register-first-step__button-wrapper {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.register-first-step__button-wrapper button {\n\theight: 56px;\n\twidth: fit-content;\n\tborder-radius: 12px;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-size: 18px;\n\tline-height: 22px;\n\tcolor: var(--background);\n\tbackground-color: var(--button);\n\tborder: none;\n\tcursor: pointer;\n\tfont-weight: 500;\n\ttransition: 0.3s;\n}\n\n.register-first-step__button-wrapper button:disabled {\n\topacity: 0.5;\n}\n\n.register-first-step__button-wrapper button:disabled:hover {\n\tbackground-color: var(--button);\n}\n\n.register-first-step__button-wrapper button:hover {\n\tbackground-color: var(--button-hover);\n\ttransition: 0.3s;\n}\n\n.register-first-step__tiktok-banner {\n\tbackground-color: var(--button);\n\tborder-radius: 12px;\n\tpadding: 16px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 16px;\n\tcolor: #FFFFFF;\n}\n\n.register-first-step__tiktok-banner-content {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 16px;\n}\n\n@media (max-width: 1150px) {\n\t.register-first-step-wrapper {\n\t\theight: 100vh;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 450px;\n\t}\n\n\t.register-right-side {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tbackground-color: var(--button);\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t.register-right-side img {\n\t\tmax-width: 400px;\n\t\twidth: 100%;\n\t}\n\n\t.register-first-step__form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding: 40px;\n\t\theight: 100vh;\n\t\toverflow-y: auto;\n\t\tposition: relative;\n\t\tmargin: auto 0;\n\t\tgap: 24px;\n\t}\n}\n\n@media (max-width: 950px) {\n\t.register-first-step-wrapper {\n\t\theight: 100vh;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr;\n\t}\n\n\t.register-right-side {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tbackground-color: var(--button);\n\t\tdisplay: none;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t.register-first-step__form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding: 50px 20px;\n\t\theight: 100vh;\n\t\toverflow-y: auto;\n\t\tposition: relative;\n\t\tjustify-content: start;\n\t\tgap: 16px;\n\t}\n\n\t.register-first-step__fields {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 16px;\n\t}\n\n\t.register-first-step__back {\n\t\tposition: fixed;\n\t\ttop: 16px;\n\t\tleft: 20px;\n\t\tcolor: var(--text);\n\t\tfont-size: 20px;\n\t\tcursor: pointer;\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder-radius: 50%;\n\t\tbackground-color: var(--button);\n\t\ttransition: 0.3s;\n\t}\n\n\t.auth-title {\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-size: 22px;\n\t\tline-height: 26px;\n\t\tcolor: var(--dark);\n\t}\n\n\t.register-first-step__have-account {\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-size: 15px;\n\t\tline-height: 18px;\n\t\tmargin-top: 8px;\n\t}\n\n\t.register-first-step__agree-to-terms {\n\t\tfont-size: 15px;\n\t\tline-height: 18px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tcolor: var(--dark);\n\t\tmargin-top: 8px;\n\t}\n}\n\n.registration-username-hint {\n\topacity: 0.3;\n\tposition: absolute;\n\tleft: 356px;\n\ttop: 30%;\n}\n\n.domain-style {\n\tcolor: #a8a8a8b7;\n\tpadding-right: 12px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 8px;\n}\n\n.register-input-relative-group {\n\tposition: relative;\n\t/* border-radius: 12px; */\n\t/* overflow: hidden; */\n\twidth: 100%;\n}\n\n.register-input-group-domain {\n\tposition: absolute;\n\ttop: 1px;\n\tright: 1px;\n\tborder-top-right-radius: 13px;\n\tborder-bottom-right-radius: 13px;\n\theight: calc(100% - 2px);\n}\n\n.block-affiliate-code {\n\tposition: relative;\n}\n\n.affiliate-code-check-loading {\n\tanimation: spin 1s infinite linear;\n\tposition: absolute;\n\tright: 16px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tcolor: rgb(144, 144, 226);\n}\n\n.affiliate-code-check-done {\n\tposition: absolute;\n\tright: 16px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tcolor: rgb(16, 181, 16);\n}\n\n.affiliate-code-check-error {\n\tposition: absolute;\n\tright: 16px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tcolor: red;\n}\n\n.affiliate-code-tooltip-error > .tooltip-inner {\n\tbackground-color: #ffe8e8;\n\tcolor: red;\n\tborder: 1px solid red;\n\tposition: relative;\n\tleft: 450px;\n\tbottom: 10px;\n}\n\n.affiliate-code-tooltip-error > .tooltip-arrow {\n\tdisplay: none !important;\n}\n\n@keyframes spin {\n\tfrom {\n\t\ttransform: scale(1) rotate(0deg);\n\t}\n\n\tto {\n\t\ttransform: scale(1) rotate(360deg);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
